var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.selections.length > 0)?_c('BetSlipCompact',{attrs:{"coefficient":_vm.totalCoefficient,"stake":_vm.rawStake,"potentialWin":_vm.maxPotentialWin,"hasLiveEvents":_vm.hasLiveEvents,"numberOfEvents":this.selections.length},on:{"expand":_vm.onExpandClick}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45feab00","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/mobile/shared/components/BetSlipCompact/BetSlipCompactContainer.vue
// module id = 2020
// module chunks = 0